/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LangInput = "de" | "en" | "es" | "fr" | "it";
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopFiltersCustomPage_root$ref: FragmentReference;
declare export opaque type TopFiltersCustomPage_root$fragmentType: TopFiltersCustomPage_root$ref;
export type TopFiltersCustomPage_root = {|
  +aggregatorCustomPageBySlug: ?{|
    +filters: {|
      +places: ?$ReadOnlyArray<{|
        +slug: string,
        +lang: LangInput,
        +label: string,
      |}>
    |}
  |},
  +$refType: TopFiltersCustomPage_root$ref,
|};
export type TopFiltersCustomPage_root$data = TopFiltersCustomPage_root;
export type TopFiltersCustomPage_root$key = {
  +$data?: TopFiltersCustomPage_root$data,
  +$fragmentRefs: TopFiltersCustomPage_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "slug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopFiltersCustomPage_root",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "slug"
        }
      ],
      "concreteType": "AggregatorCustomPage",
      "kind": "LinkedField",
      "name": "aggregatorCustomPageBySlug",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListingFilters",
          "kind": "LinkedField",
          "name": "filters",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "places",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lang",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '8b634cd45ee7437afb295434fb09331a';

export default node;
